import { render } from "./AssetGroupWithLocationFormModal.vue?vue&type=template&id=47fc8d38&scoped=true&ts=true"
import script from "./AssetGroupWithLocationFormModal.vue?vue&type=script&lang=ts"
export * from "./AssetGroupWithLocationFormModal.vue?vue&type=script&lang=ts"

import "./AssetGroupWithLocationFormModal.vue?vue&type=style&index=0&id=47fc8d38&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fc8d38"]])

export default __exports__